/* eslint-disable import/prefer-default-export */
import styled from "styled-components";

export const Container = styled.div`
  padding: 24px 32px;

  .content-manager-header {
    margin-bottom: 4px;
  }

  .dashboard-kpis {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
  }

  .dashboard-kpi-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 10px 8px;
    border: 1px solid #f0f0f0;
    border-radius: 12px;
    background: #fff;
    text-align: center;
  }

  .dashboard-kpi-card--clickable {
    cursor: pointer;
    transition: background-color 0.2s, border-color 0.2s, box-shadow 0.2s;
  }

  .dashboard-kpi-card--clickable:hover {
    background: #fffdf0;
    border-color: #ffe58f;
    box-shadow: 0 2px 8px rgba(212, 136, 6, 0.08);
  }

  .dashboard-kpi-value {
    font-family: "SF Pro Display", sans-serif;
    font-size: 24px;
    font-weight: 700;
    line-height: 1.1;
    color: #3d3b48;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .dashboard-kpi-label {
    font-size: 13px;
    line-height: 1.3;
    color: #8c8c8c;
    font-weight: 500;
  }

  .content-tabs {
    background: #fff;
    margin-top: 20px;
  }
  .content-tabs .ant-tabs-tab {
    padding: 12px 20px;
  }

  .table-filter {
    margin: 10px 20px 10px 0;
  }
  .table-search {
    max-width: 50%;
  }

  .challenge-session-active > td {
    background-color: #fffdf0 !important;
  }

  .challenge-session-active:hover > td {
    background-color: #fffdf0 !important;
  }

  .challenge-title-cell {
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }

  .challenge-active-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: linear-gradient(135deg, #fff7e6 0%, #ffe58f 100%);
    color: #d48806;
    font-size: 12px;
    flex-shrink: 0;
    box-shadow: 0 1px 4px rgba(212, 136, 6, 0.25);
  }

  .challenge-active-title {
    font-weight: 600;
    color: #262626;
  }

  .challenge-visible-cell {
    display: flex;
    align-items: flex-start;
    gap: 10px;
  }

  .challenge-visible-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    flex-shrink: 0;
    height: 18px;
    margin-top: 1px;
  }

  .challenge-visible-icon--draft {
    color: #bfbfbf;
  }

  .challenge-visible-icon--published {
    color: #52c41a;
  }

  .challenge-visible-icon--scheduled {
    color: #faad14;
  }

  .challenge-visible-text {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }

  .challenge-visible-label {
    font-weight: 600;
    color: #262626;
    font-size: 14px;
    line-height: 1.3;
  }

  .challenge-visible-status {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0 4px;
    font-size: 12px;
    line-height: 1.3;
  }

  .challenge-visible-scheduled-time {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: inherit;
    cursor: default;
    white-space: nowrap;
  }

  .challenge-visible-scheduled-sep {
    margin: 0 2px;
  }

  .challenge-visible-status--draft {
    color: #bfbfbf;
  }

  .challenge-visible-status--published {
    color: #52c41a;
  }

  .challenge-visible-status--scheduled {
    color: #faad14;
  }

  .challenge-visible-group-link {
    color: #262626;
    font-weight: 600;
    text-decoration: none;
    border-bottom: 1px solid transparent;
    transition: color 0.2s, border-color 0.2s;
  }

  .challenge-visible-group-link:hover {
    color: #1890ff;
    border-bottom-color: #1890ff;
  }

  .challenge-daily-contents-title {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 16px;
    color: #262626;
  }

  .challenge-day-block {
    margin-bottom: 20px;
    padding: 16px 18px;
    background: #fafafa;
    border-radius: 10px;
    border: 1px solid #f0f0f0;
  }

  .challenge-day-block:last-child {
    margin-bottom: 0;
  }

  .challenge-day-block-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 14px;
    color: #262626;
  }

  .challenge-day-block-number {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 52px;
    padding: 2px 10px;
    border-radius: 999px;
    background: #e6f7ff;
    color: #1890ff;
    font-size: 12px;
    font-weight: 600;
  }

  .challenge-day-block-date {
    font-size: 11px;
    font-weight: 400;
    color: #8c8c8c;
  }

  .challenge-day-cards {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .challenge-day-card {
    padding: 14px 16px;
    background: #fff;
    border-radius: 8px;
    border: 1px solid #f0f0f0;
    border-left: 3px solid transparent;
    transition: box-shadow 0.2s, border-color 0.2s;
  }

  .challenge-day-card:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  }

  .challenge-day-card--reflection {
    border-left-color: #1890ff;
    background: linear-gradient(135deg, #f0f9ff 0%, #fff 55%);
  }

  .challenge-day-card--insight {
    border-left-color: #faad14;
    background: linear-gradient(135deg, #fffbe6 0%, #fff 55%);
  }

  .challenge-day-card--action {
    border-left-color: #52c41a;
    background: linear-gradient(135deg, #f6ffed 0%, #fff 55%);
  }

  .challenge-day-card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 10px;
  }

  .challenge-day-card-title {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    font-weight: 600;
    color: #262626;
    flex-shrink: 0;
  }

  .challenge-day-card-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 6px;
    font-size: 13px;
    flex-shrink: 0;
  }

  .challenge-day-card--reflection .challenge-day-card-icon {
    color: #1890ff;
    background: #e6f7ff;
  }

  .challenge-day-card--insight .challenge-day-card-icon {
    color: #d48806;
    background: #fff7e6;
  }

  .challenge-day-card--action .challenge-day-card-icon {
    color: #389e0d;
    background: #f6ffed;
  }

  .challenge-day-card-stats {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    justify-content: flex-end;
  }

  .challenge-day-stat {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.85);
    border: 1px solid #f0f0f0;
    font-size: 11px;
    line-height: 1.4;
    white-space: nowrap;
  }

  .challenge-day-stat-label {
    color: #8c8c8c;
  }

  .challenge-day-stat-value {
    font-weight: 600;
    color: #389e0d;
  }

  .challenge-day-card-content {
    font-size: 13px;
    line-height: 1.6;
    color: #595959;
    white-space: pre-wrap;
    word-break: break-word;
  }

  .challenge-day-card-link {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-top: 10px;
    font-size: 12px;
    font-weight: 500;
    color: #1890ff;
    text-decoration: none;
    transition: color 0.2s;
  }

  .challenge-day-card-link:hover {
    color: #40a9ff;
    text-decoration: underline;
  }
`;

export const CreateContentMenu = styled.div`
  .create-content-section + .create-content-section {
    margin-top: 24px;
  }

  .create-content-section-label {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #8c8c8c;
    margin-bottom: 10px;
  }

  .create-content-challenge-list,
  .create-content-nudge-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .create-content-option {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 14px 16px;
    border: 1px solid #f0f0f0;
    border-radius: 10px;
    background: #fff;
    cursor: pointer;
    text-align: left;
    transition: background-color 0.2s, border-color 0.2s;
  }

  .create-content-option:hover {
    background: #fffdf0;
    border-color: #ffe58f;
  }

  .create-content-option-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    font-size: 16px;
    flex-shrink: 0;
    color: #595959;
    background: #f5f5f5;
  }

  .create-content-option-icon--large {
    width: 36px;
    height: 36px;
    font-size: 18px;
  }

  .create-content-option-icon--purple {
    color: #722ed1;
    background: #f9f0ff;
  }

  .create-content-option-icon--green {
    color: #389e0d;
    background: #f6ffed;
  }

  .create-content-option-body {
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1;
    min-width: 0;
  }

  .create-content-option-title {
    font-size: 14px;
    font-weight: 600;
    color: #262626;
    line-height: 1.3;
  }

  .create-content-option-subtitle {
    font-size: 12px;
    color: #8c8c8c;
    line-height: 1.3;
  }

  .create-content-option-arrow {
    color: #bfbfbf;
    font-size: 12px;
    flex-shrink: 0;
  }
`;
